import React from 'react';

export default function InsightsReport() {
  return (
    <section className="py-6 flex items-center justify-center" style={{ minHeight: '400px' }}>
      <div className="text-center">
        <div className="text-6xl mb-4">💡</div>
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Insights Coming Soon</h2>
        <p className="text-sm text-gray-500 dark:text-gray-400">Advanced analytics and insights will be available here</p>
      </div>
    </section>
  );
}
